import types from "../types";

export const fetchpoints = (points) => ({
  type: types.pointsTypes.FETCH_USER_TODAYS_POINTS,
  payload: points,
});
